/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import BackgroundBlogCard from "examples/Cards/BlogCards/BackgroundBlogCard";

// Presentation page sections
import Download from "pages/Presentation/sections/Download";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import logo from "assets/images/alpha-logo.png";
import bgImage from "assets/images/baku-project.jpg";
import mauritiusProject from "assets/images/mauritius-project.jpg";

function Presentation() {
  return (
    <>
      <MKBox position="fixed" top="0.5rem" width="100%" zIndex={10}>
        <Container sx={{ maxWidth: "1200px !important", mx: "auto" }}>
          <DefaultNavbar
            brand={
              <MKBox component="img" src={logo} alt="Alpha Group" width="60px" sx={{ py: 0 }} />
            }
            routes={routes}
            action={{
              type: "external",
              route: "mailto:info@alphagrouplimited.com",
              label: "Contact Email",
              color: "primary",
            }}
          />
        </Container>
      </MKBox>
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: `linear-gradient(rgba(34, 34, 34, 0.6), rgba(34, 34, 34, 0.6)), url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={6} justifyContent="center" mx="auto" textAlign="center">
            <MKTypography
              variant="h1"
              color="white"
              mt={4}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              ALPHA GROUP
            </MKTypography>
            <MKTypography
              variant="h4"
              color="white"
              fontWeight="regular"
              mb={3}
              sx={{ opacity: 0.9 }}
            >
              LUXURY REAL ESTATE & INFRASTRUCTURE
            </MKTypography>
            <MKTypography
              variant="body1"
              color="white"
              textAlign="center"
              px={{ xs: 3, lg: 2 }}
              mt={1}
            >
              Leading premium construction and architectural excellence across <b>Azerbaijan</b> and{" "}
              <b>Mauritius</b>. Delivering world-class residential and commercial landmarks.
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox py={12}>
          <Container>
            <Grid
              container
              item
              xs={12}
              lg={10}
              flexDirection="column"
              alignItems="center"
              sx={{ textAlign: "center", my: 6, mx: "auto", px: 0.75 }}
            >
              <MKTypography variant="h2" fontWeight="bold">
                Pioneering Markets in Azerbaijan & Mauritius
              </MKTypography>
              <MKTypography variant="body1" color="text" mt={2}>
                Alpha Group, established in 1996, has pivoted its global focus to the high-growth
                markets of <b>Azerbaijan and Mauritius</b>. With a strong commitment to quality and
                driven by passion, we have achieved remarkable success in these regions.
              </MKTypography>
              <MKTypography variant="body1" color="text" mt={2}>
                To date, we have successfully developed and constructed over{" "}
                <b>10 million sq. ft.</b> of residential, commercial, and industrial projects.
                Currently, the company has major infrastructure projects underway in <b>Baku</b> and{" "}
                <b>Mauritius</b>, encompassing a total area of about <b>3 million sq. ft.</b> Alpha
                Group has earned a commendable reputation for delivering high-quality projects
                within strict timelines.
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
        <Container>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={6}>
              <BackgroundBlogCard
                image={bgImage}
                title="Azerbaijan Portfolio"
                description="Developing futuristic skyscrapers and high-end commercial hubs in Baku. Redefining the skyline with architectural masterpieces."
                action={{
                  type: "internal",
                  route: "/azerbaijan-projects",
                  label: "View Baku Projects",
                }}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <BackgroundBlogCard
                image={mauritiusProject}
                title="Mauritius Portfolio"
                description="Luxury sustainable resorts and premium coastal residential developments. Blending modern architecture with tropical elegance."
                action={{
                  type: "internal",
                  route: "/mauritius-projects",
                  label: "Explore Mauritius",
                }}
              />
            </Grid>
          </Grid>
        </Container>
        <Download />
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Presentation;
